import { Spinner } from '@ntconsult/aluma-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks';
import type { Role } from '../types/Role';
import { saveRedirect } from '../utils/redirectAfterLogin';

type ProtectedRouteProps = {
  allowedRoles?: Role[];
};

export function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <Spinner layout="fullPage" />;

  if (!isAuthenticated) {
    saveRedirect(location.pathname + location.search);
    const from = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?from=${from}`} replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const allowed = user?.roles.some((r) => allowedRoles.includes(r));
    if (!allowed) return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
